/**
 * Combine all sagas in this file and export the rootSaga.
 */

import {all} from 'redux-saga/effects';
import orderSaga from '../pages/orders/saga';
import bundleSaga from '../pages/bundles/saga';
import uploadInfoSaga from '../pages/uploadInfo/saga';
import loginSaga from '../pages/login/saga';
import driversSaga from '../pages/drivers/saga';
import userSaga from '../pages/users/saga';
import fleetsSaga from '../pages/fleets/saga';

export default function* rootSaga() {
  yield all([
    loginSaga(),
    orderSaga(),
    fleetsSaga(),
    bundleSaga(),
    uploadInfoSaga(),
    driversSaga(),
    userSaga(),
  ]);
}
